import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAudioboomComponent } from './simple-icons-audioboom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAudioboomComponent ],
    exports:      [ SimpleIconsAudioboomComponent ],
    bootstrap:    []
})
export class SimpleIconsAudioboomModule {}
